import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-assigned-donors-modal',
  templateUrl: './assigned-donors-modal.component.html',
  styleUrl: './assigned-donors-modal.component.scss'
})
export class AssignedDonorsModalComponent implements OnInit {
  @Input() user!: User;
  @Input() donors!: any[];
  assignedDonors: any[] = [];
  userName!: string;
  loading = true;
  errorMessage: string | null = null;

  constructor(public activeModal: NgbActiveModal, private userService: UserService) {}

  ngOnInit() {
    if (this.user) {
      this.userName = `${this.user.firstName} ${this.user.lastName}`

      
      this.assignedDonors = this.donors.filter((donor: any) => donor.assignedTo === this.user.email);
      this.loading = false;
      
      // this.userService.getDonorsAssignedToUser(this.userEmail).subscribe({
      //   next: (donors) => {
      //     this.donors = donors;
      //     this.loading = false;
      //   },
      //   error: () => {
      //     this.errorMessage = "Failed to load assigned donors.";
      //     this.loading = false;
      //   },
      // });
    }
  }

  closeModal() {
    this.activeModal.close();
  }
}

